exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".NewContactsIcon__container{color:#000;background-color:#febf00}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/NewContactsIcon/NewContactsIcon.scss
// module id = 805
// module chunks = 0